<template>
  <div class="bg-white vform position-relative" :class="isSushi && 'montserrat-500'">
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <div class="container">
          <navigate-user-back />
        </div>
        <div class="container mt-4 pt-4">
          <div class="text-center" >
            <div :class="isSushi && 'font-25 montserrat-700'">{{ $t('message.loyaltyPts') }}</div>
            <div v-if="dbuser">{{parseInt(dbuser.RewardPoints?dbuser.RewardPoints:0)| formatNumber}}</div>
          </div>
          <hr />
          <div class="row" :class="isSushi && 'font-25 montserrat-700'">
            <div class="col-6 text-success text-center" >
              <div>{{ $t('message.ptsEarned') }}</div>
              <div
                v-if="dbuser"
              >+ {{parseInt(dbuser.EarnedRewardPoints?dbuser.EarnedRewardPoints:0)| formatNumber}}</div>
            </div>
            <div class="col-6 text-red text-center">
              <div>{{ $t('message.ptsSpent') }}</div>
              <div
                v-if="dbuser"
              >- {{parseInt(dbuser.SpentRewardPoints?dbuser.SpentRewardPoints:0)| formatNumber}}</div>
            </div>
          </div>
          <div v-show="error" class="w-100 mt-4">
            <div class="alert alert-red" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-show="success" class="w-100 mt-4">
            <div class="alert alert-success" role="alert">
              <strong>{{ $t('message.orderPlacedSuccessfully') }}</strong>
            </div>
          </div>
          <hr />
        </div>
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items ml-5">
              <div class="order-item-details col-sm-7">
                <div>{{ $t('message.orderNo') }}.</div>
                <div>{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</div>
              </div>
              <div class="col-sm-4 text-right mr-5">
                <div class="color-gray fdate" v-html="getCreateDate(order)" />
                <div class="order-item-cost padding-5-left">
                  <span
                    class="text-red"
                    v-if="order && parseInt(order.RedeemPoints)>0"
                  >&nbsp;-{{parseInt(order.RedeemPoints) | formatNumber}} pts</span>
                  <span
                    class="text-success"
                    v-if="order && parseInt(order.RewardPoints)>0"
                  >&nbsp;+{{parseInt(order.RewardPoints) | formatNumber}} pts</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message :message="getNoOrderAvailable" />
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import shared from "../../sharedscripts/user/Loyalty.js";
import Message from "./../shared/Message";
import { mapGetters } from "vuex";
import NavigateUserBack from "@/components/user/partials/navigateUserBack";
export default {
  components: {
    NavigateUserBack,
    Pagination,
    Message
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "hqDoc", "currentStoreDoc"]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods
  }
};
</script>
